module.exports = __webpack_public_path__ + "img/bleken.89e685fc.jpg";